export default "__VITE_ASSET__6ffe34e6__"